// extracted by mini-css-extract-plugin
export default {"Box":"filter-input-container-module__Box--oov35","is-focused":"filter-input-container-module__is-focused--EXLw0"};